import { useTranslation } from 'react-i18next';

import { SrOnly } from '../SrOnly';
import { Spinner, Wrapper } from './wrapper';

interface Props {
  inline?: boolean;
  inlineBlock?: boolean;
  center?: boolean;
}

const Loader = ({ inline, inlineBlock, center }: Props) => {
  const { t } = useTranslation('common');

  return (
    <Wrapper $inline={inline} $inlineBlock={inlineBlock} $center={center}>
      <Spinner aria-hidden="true" />
      <SrOnly suppressHydrationWarning>{t('loading', { ns: 'common' })}</SrOnly>
    </Wrapper>
  );
};

export default Loader;
